export const assetsConst = {
  Logo: 'assets/images/logo.svg',
  noDataFound: 'assets/images/Nodat-found.gif',
  placeHolder: 'assets/images/placeholder.png',
  dashBoardIcon: 'assets/images/dash.svg',
  userIcon: 'assets/images/user.svg',
  bankIcon: 'assets/images/user.svg',
  addIcon: 'assets/images/add.svg',
  upload: 'assets/images/upload.jpg',
  reportIcon: 'assets/images/reports.svg',
  subAdminIcon: 'assets/images/sub_admin.svg',
  loanIcon: 'assets/images/sub_admin.svg',
  analyticsIcon: 'assets/images/earn_report.svg',
  cmsIcon: 'assets/images/cms.svg',
  deleteIcon: 'assets/images/delete_icon.svg',
  logoutLogo: 'assets/images/logout.svg',
  passwordLogo: 'assets/images/password.svg',
  userLogo: 'assets/images/user.svg',
  profileLogo: 'assets/images/profile.png',
  placeHolderLogo: 'assets/images/placeholder.png',
  logoIcon: 'assets/images/logo.png',
  fixedRate: 'assets/images/fixed_rate.png',
  noteIcon: 'assets/images/notification-bell.png',
  vendorIcon: 'assets/images/ord5.svg',
  FactoryIcon: 'assets/images/factory.svg',
  edit_icon: 'assets/images/edit_icon.svg',
  viewIcon: 'assets/images/eye.svg',
  UserProfile: 'assets/images/user.png',
  cameraIcon: 'assets/images/camera_icon.svg',
  searchIcon: 'assets/images/search_icon.svg',
  sideLogoutIcon: 'assets/images/log-out.svg',
  reviewIcon: 'assets/images/review.svg',
  adIcon: 'assets/images/ad.svg',
  couponsIcon: 'assets/images/coupons.svg',
  paymentsIcon: 'assets/images/payments.svg',
  manageorderIcon: 'assets/images/manage-order.svg',
  productsIcon: 'assets/images/products.svg',
  productcategoryicon: 'assets/images/product-category.svg',
  totaluserIcon: 'assets/images/total_user.svg',
  payoutIcon: 'assets/images/paylout-icon.svg',
  orderIcon: 'assets/images/order.svg',
  returnIcon: 'assets/images/returns.svg',
  driverIcon: 'assets/images/driver.svg',
  vehicleIcon: 'assets/images/vehicle.svg',
  teamsIcon: 'assets/images/teams.svg',
  pricingIcon: 'assets/images/pricing.svg',
  bookingsIcon: 'assets/images/bookings.svg',
  toolsIcon: 'assets/images/tools.svg',
  copyIcon: 'assets/images/dublicate.svg',
  settingIcon: 'assets/images/setting.svg',
  offerIcon: 'assets/images/off.svg',
  locationIcon: 'assets/images/location.svg',
  deleteIconSearch: 'assets/images/delete_icon.svg',
  soundFile: 'assets/sounds/notification-sound1.mp3',
  AreaIcon: 'assets/images/area_icon.svg',
  vendorReportIcon: 'assets/images/merchant_report.svg',
  productPerformanceIcon: 'assets/images/sales_report.svg',
  reportsIcon: 'assets/images/reports.svg',
  couponUsageIcon: 'assets/images/earn_report.svg',
};
